<div
  class="flex flex-1 flex-col"
  [ngStyle]="getBackgroundStyles()"
  [style.backgroundColor]="backgroundColor | contentBuilderColor"
>
  @if (header) {
    <div
      id="header"
      class="flex-shrink-0"
      [style.backgroundColor]="hasBackgroundImage ? null : (backgroundColor | contentBuilderColor)"
      [style.color]="textColor | contentBuilderColor"
    >
      <app-block-list [blockIdList]="header"></app-block-list>
    </div>
  }

  <div
    class="flex flex-1 flex-col overflow-y-auto"
    [style.backgroundColor]="hasBackgroundImage ? null : (backgroundColor | contentBuilderColor)"
    [style.color]="textColor | contentBuilderColor"
  >
    <div class="kiosk-xl:pb-64 flex h-full flex-col items-center justify-center p-10 text-center">
      <!-- Heading -->
      <h1
        class="mb-16 text-center text-6xl font-bold"
        [style.color]="accentColor | contentBuilderColor"
      >
        {{ title | translate }}
      </h1>

      <!-- Cards -->
      <div class="mb-32 grid grid-cols-2 gap-12">
        @for (distributionModeItem of availableDistributionModeItems; track distributionModeItem) {
          <div class="">
            <app-kiosk-active-button-atom
              [activeBackground]="activeCardBackgroundColor"
              [activeTextColor]="activeCardTextColor"
              [inactiveBackground]="inactiveCardBackgroundColor"
              [inactiveTextColor]="inactiveCardTextColor"
              [label]="distributionModeItem.label | translate"
              [isActive]="distributionModeItem.value === selectedDistributionMode"
              (clickEmitter)="selectDistributionMode(distributionModeItem)"
            >
              @if (distributionModeItem.icon) {
                <i class="icon {{ distributionModeItem.icon }} mb-4"></i>
              }
            </app-kiosk-active-button-atom>
          </div>
        }
      </div>

      <!-- Date and time picker -->
      @if (preorderingAllowed()) {
        <div>
          <h1
            class="mb-16 mt-32 text-center text-6xl font-bold"
            [style.color]="accentColor | contentBuilderColor"
          >
            {{ 'parameters.for-when' | translate }}
          </h1>
          <div class="mb-32 grid grid-cols-2 gap-12">
            <app-kiosk-active-button-atom
              [label]="'parameters.asap' | translate"
              [activeBackground]="activeCardBackgroundColor"
              [activeTextColor]="activeCardTextColor"
              [inactiveBackground]="inactiveCardBackgroundColor"
              [inactiveTextColor]="inactiveCardTextColor"
              [isActive]="selectedWantedAtType === 'asap'"
              (clickEmitter)="onWantedAtTypeChanged('asap')"
            >
            </app-kiosk-active-button-atom>
            <app-kiosk-active-button-atom
              [label]="'parameters.for-later' | translate"
              [activeBackground]="activeCardBackgroundColor"
              [activeTextColor]="activeCardTextColor"
              [inactiveBackground]="inactiveCardBackgroundColor"
              [inactiveTextColor]="inactiveCardTextColor"
              [isActive]="selectedWantedAtType === 'later'"
              (clickEmitter)="onWantedAtTypeChanged('later')"
            >
            </app-kiosk-active-button-atom>
          </div>
          @if (selectedWantedAtType === 'later') {
            <div class="mb-5">
              <select
                class="text-4xl"
                [(ngModel)]="selectedDateSlot"
                (change)="changeDate()"
              >
                @for (item of availableDatesSlots; track item) {
                  <option [ngValue]="item.value">
                    {{ item.label }}
                  </option>
                }
              </select>
              <select
                class="text-4xl"
                [(ngModel)]="selectedTimeSlot"
              >
                @for (item of availableTimesSlots; track item) {
                  <option [ngValue]="item.slot.start">
                    {{ item.label }}
                  </option>
                }
              </select>
            </div>
          }
        </div>
      }
    </div>
  </div>
  <div class="w-full self-end">
    <app-kiosk-footer-double-button-atom
      [backgroundColor]="hasBackgroundImage ? undefined : backgroundColor"
      [textColor]="textColor"
      firstButtonLabel="Annuler"
      [secondButtonBackgroundColor]="secondaryButtonBackgroundColor"
      [secondButtonTextColor]="secondaryButtonTextColor"
      [secondButtonDisabled]="!canValidate()"
      secondButtonLabel="Valider"
      (onFirstButtonClick)="navigateto('/')"
      (onSecondButtonClick)="navigateto(linkUrl, true)"
    >
    </app-kiosk-footer-double-button-atom>
  </div>
</div>
